import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from "react-router-dom";
import Formatter from "./pages/formatter";
import Converter from "./pages/converter";
import About from "./pages/about";
import Home from "./pages/home";
import Privacy from "./pages/privacy";
import { ThemeProvider } from "./ThemeContext";
import "./app.css";

window.SITE_NAME = "formaticus"

const entries = {
"json": "JSON",
"xml": "XML",
"html": "HTML",
"js": "JavaScript",
"jsx": "JSX",
"yml": "YAML",
"css": "CSS",
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home entries={entries} />} />
          <Route path="/formatter/:type" element={<Formatter entries={entries} />} />
          <Route path="/converter/:type" element={<Converter entries={entries} />} />
          <Route path="/about" element={<About entries={entries} />} />
          <Route path="/privacy" element={<Privacy entries={entries} />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(<App />);
